export interface Show {
  id: number;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  rating: number;
  year: number;
  seasons: number;
  status: string;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  tags: string[];
  updateDay: string;
  views: number;
  imageUrl: string;
  heroImageUrl: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-2-line', count: 24 },
  { name: '剧情', slug: 'drama', icon: 'ri-emotion-line', count: 6 },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', count: 4 },
  { name: '科幻', slug: 'sci-fi', icon: 'ri-rocket-line', count: 4 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-happy-line', count: 4 },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line', count: 3 },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', count: 2 },
  { name: '动画', slug: 'animation', icon: 'ri-palette-line', count: 1 },
];

export const shows: Show[] = [
  {
    id: 1,
    title: '权力的游戏',
    englishTitle: 'Game of Thrones',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.4,
    year: 2011,
    seasons: 8,
    status: '已完结',
    description: '维斯特洛大陆上，七大王国为争夺铁王座展开了一场史诗级的权力斗争。龙、异鬼与魔法的力量重新苏醒，将改变所有人的命运。',
    longDescription: '《权力的游戏》改编自乔治·R·R·马丁的奇幻小说系列《冰与火之歌》。故事发生在一个虚构的中世纪世界——维斯特洛大陆，讲述了七大王国贵族家族之间为争夺铁王座而进行的残酷权力斗争。与此同时，在北境长城之外，古老而神秘的异鬼正在集结，准备席卷整个大陆。而在东方，流亡的坦格利安家族末裔丹妮莉丝正逐渐成长，她拥有三只龙，意图重返维斯特洛夺回属于自己的一切。本剧以其宏大的世界观、复杂的人物关系、出人意料的情节转折和精良的制作水准，成为电视史上最具影响力的剧集之一。',
    director: '大卫·贝尼奥夫 / D·B·威斯',
    cast: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂', '尼古拉·科斯特-瓦尔道'],
    tags: ['史诗', '奇幻', '权谋', '中世纪'],
    updateDay: '已完结',
    views: 9850000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20TV%20show%20Game%20of%20Thrones%20promotional%20poster%20with%20dramatic%20cinematic%20lighting%20dark%20moody%20atmosphere%20iron%20throne%20silhouette%20professional%20poster%20design%20simple%20dark%20background%20high%20contrast%20film%20grain%20texture&width=400&height=560&seq=show-card-01&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20Game%20of%20Thrones%20style%20dramatic%20cinematic%20wide%20shot%20dark%20castle%20silhouette%20against%20stormy%20sky%20dragons%20flying%20in%20distance%20epic%20scale%20professional%20photography%20moody%20atmosphere&width=1400&height=700&seq=hero-show-01&orientation=landscape'
  },
  {
    id: 2,
    title: '怪奇物语',
    englishTitle: 'Stranger Things',
    category: '科幻',
    categorySlug: 'sci-fi',
    rating: 8.9,
    year: 2016,
    seasons: 4,
    status: '连载中',
    description: '一个小男孩神秘失踪后，他的朋友们、家人和当地警方卷入了一个涉及秘密实验、超自然力量和一个小女孩的神秘事件中。',
    longDescription: '《怪奇物语》以1980年代的印第安纳州霍金斯镇为背景，讲述了一群青少年在寻找失踪朋友威尔的过程中，意外揭开了一个涉及政府秘密实验的惊天阴谋。他们遇到了拥有超能力的女孩小十一，并发现了一个与我们的世界平行的恐怖维度——"颠倒世界"。随着剧情发展，来自颠倒世界的威胁越来越大，这群少年和他们的家人必须团结一致，面对越来越强大的超自然敌人。本剧完美融合了科幻、恐怖与成长主题，充满80年代流行文化致敬，是Netflix最成功的原创剧集之一。',
    director: '达菲兄弟',
    cast: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯', '伽塔·马塔拉佐'],
    tags: ['科幻', '恐怖', '80年代', '青春'],
    updateDay: '每周五更新',
    views: 8720000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Stranger%20Things%20TV%20show%20poster%201980s%20retro%20style%20neon%20lights%20dark%20moody%20atmosphere%20group%20of%20kids%20on%20bicycles%20silhouette%20professional%20poster%20design%20simple%20background%20nostalgic%20feel&width=400&height=560&seq=show-card-02&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=1980s%20small%20town%20at%20night%20Stranger%20Things%20style%20neon%20red%20glow%20mysterious%20dark%20forest%20bicycles%20on%20empty%20road%20cinematic%20wide%20shot%20nostalgic%20atmosphere%20foggy%20night&width=1400&height=700&seq=hero-show-02&orientation=landscape'
  },
  {
    id: 3,
    title: '绝命毒师',
    englishTitle: 'Breaking Bad',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.6,
    year: 2008,
    seasons: 5,
    status: '已完结',
    description: '一位普通的高中化学老师在得知自己身患绝症后，为了给家人留下足够的财产，开始利用自己的化学知识制造冰毒，从此走上了一条不归路。',
    longDescription: '《绝命毒师》讲述了高中化学老师沃尔特·怀特的故事。当他被诊断出患有晚期肺癌后，这位看似平凡的中年男子做出了一个惊人的决定——利用自己的化学专业知识，与他以前的学生杰西·平克曼合作制造和销售冰毒。沃尔特以"海森堡"为化名，从一个为家庭着想的父亲逐渐蜕变为冷酷无情的毒枭。本剧以其精湛的剧本、出色的角色塑造和紧张刺激的剧情发展，被广泛认为是有史以来最伟大的电视剧之一，斩获多项艾美奖和金球奖。',
    director: '文斯·吉里根',
    cast: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯', '贝琪·勃兰特'],
    tags: ['犯罪', '黑色幽默', '人性', '经典'],
    updateDay: '已完结',
    views: 9120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Breaking%20Bad%20TV%20show%20poster%20desert%20landscape%20meth%20lab%20RV%20in%20distance%20dramatic%20warm%20tones%20yellow%20haze%20professional%20poster%20design%20simple%20background%20high%20contrast%20man%20in%20hazmat%20suit&width=400&height=560&seq=show-card-03&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Desert%20landscape%20New%20Mexico%20Breaking%20Bad%20style%20wide%20cinematic%20shot%20warm%20golden%20sunset%20light%20RV%20truck%20on%20empty%20highway%20dramatic%20sky%20professional%20photography%20vast%20horizon&width=1400&height=700&seq=hero-show-03&orientation=landscape'
  },
  {
    id: 4,
    title: '黑镜',
    englishTitle: 'Black Mirror',
    category: '科幻',
    categorySlug: 'sci-fi',
    rating: 9.0,
    year: 2011,
    seasons: 6,
    status: '连载中',
    description: '一部探讨现代科技对人类生活影响的独立单元剧，每一集都以黑暗讽刺的方式展现技术发展可能带来的可怕后果。',
    longDescription: '《黑镜》是一部独立单元剧，每集讲述一个完全独立的故事，探讨科技对人类社会的深远影响。从社交媒体的评级系统到意识上传数字化永生，从人工智能伴侣到虚拟现实监狱，这部剧以极其犀利和令人不安的方式，展示了科技发展可能带来的阴暗面。剧名"黑镜"暗指各种电子设备关闭后的黑色屏幕，象征着我们与科技之间令人不安的关系。本剧以其发人深省的剧情和令人震撼的结局，成为最具话题性的当代剧集之一。',
    director: '查理·布鲁克',
    cast: ['布莱丝·达拉斯·霍华德', '乔·汉姆', '麦莉·赛勒斯', '安东尼·麦凯', '海莉·阿特维尔'],
    tags: ['科幻', '惊悚', '独立单元', '社会讽刺'],
    updateDay: '不定期更新',
    views: 7650000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Black%20Mirror%20TV%20show%20poster%20dark%20technological%20dystopia%20cracked%20glass%20screen%20effect%20glitch%20art%20style%20ominous%20atmosphere%20professional%20poster%20design%20simple%20dark%20background%20digital%20corruption&width=400&height=560&seq=show-card-04&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Digital%20dystopia%20landscape%20Black%20Mirror%20style%20glitch%20art%20cracked%20digital%20screens%20futuristic%20city%20at%20night%20neon%20reflections%20ominous%20atmosphere%20cinematic%20wide%20shot%20dark%20technological%20theme&width=1400&height=700&seq=hero-show-04&orientation=landscape'
  },
  {
    id: 5,
    title: '老友记',
    englishTitle: 'Friends',
    category: '喜剧',
    categorySlug: 'comedy',
    rating: 9.7,
    year: 1994,
    seasons: 10,
    status: '已完结',
    description: '六个住在纽约曼哈顿的年轻人，在Central Perk咖啡馆和彼此的公寓中，上演了一幕幕关于友情、爱情和工作的温馨喜剧。',
    longDescription: '《老友记》是电视史上最受欢迎的情景喜剧之一，讲述了六个二十多岁的年轻人在纽约曼哈顿的生活故事。莫妮卡、瑞秋、菲比、钱德勒、乔伊和罗斯——这六个性格迥异的好朋友，他们在Central Perk咖啡馆消磨时光，在彼此的公寓里分享喜怒哀乐。从瑞秋逃婚投奔莫妮卡开始，到十季之间的无数欢笑哭闹，这部剧以幽默温暖的方式描绘了友情、爱情和成长的点点滴滴。《老友记》不仅是一部喜剧，更是一代人的青春记忆和流行文化符号。',
    director: '大卫·克拉尼 / 玛尔塔·考夫曼',
    cast: ['詹妮弗·安妮斯顿', '柯特妮·考克斯', '丽莎·库卓', '马特·勒布朗', '马修·派瑞', '大卫·休默'],
    tags: ['情景喜剧', '友情', '经典', '纽约'],
    updateDay: '已完结',
    views: 10500000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Friends%20TV%20show%20poster%20group%20of%20six%20young%20friends%20in%20cozy%20New%20York%20apartment%20warm%20lighting%20happy%20atmosphere%20professional%20poster%20design%20simple%20background%20comfortable%20coffee%20shop%20vibe&width=400&height=560&seq=show-card-05&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=New%20York%20City%20apartment%20building%20Friends%20TV%20show%20style%20warm%20cozy%20evening%20lighting%20iconic%20fountain%20in%20park%20cityscape%20background%20nostalgic%201990s%20feel%20comfortable%20atmosphere%20cinematic%20wide%20shot&width=1400&height=700&seq=hero-show-05&orientation=landscape'
  },
  {
    id: 6,
    title: '真探',
    englishTitle: 'True Detective',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 9.3,
    year: 2014,
    seasons: 4,
    status: '连载中',
    description: '每一季讲述一个独立的罪案故事，两个性格迥异的侦探在追查连环杀人案的过程中，逐渐被黑暗的真相所吞噬。',
    longDescription: '《真探》是一部独立季播的犯罪悬疑剧，每季讲述一个全新的故事，由不同的演员阵容出演。第一季以路易斯安那州为背景，两位侦探拉斯特和马蒂追查一起跨越17年的神秘连环杀人案，案件背后隐藏着令人不寒而栗的邪教秘密。本剧以其深刻的人物刻画、哲学思辨式的对话、阴郁压抑的氛围和精湛的演技而备受赞誉。特别是马修·麦康纳和伍迪·哈里森在第一季中的表演，被认为是电视表演的巅峰之作。',
    director: '尼克·皮佐拉托',
    cast: ['马修·麦康纳', '伍迪·哈里森', '朱迪·福斯特', '马赫沙拉·阿里', '科林·法瑞尔'],
    tags: ['悬疑', '犯罪', '独立季', '哲学'],
    updateDay: '不定期更新',
    views: 6980000,
    imageUrl: 'https://readdy.ai/api/search-image?query=True%20Detective%20TV%20show%20poster%20dark%20noir%20style%20two%20detectives%20in%20shadow%20moody%20atmosphere%20southern%20gothic%20feel%20professional%20poster%20design%20simple%20dark%20background%20mysterious%20vibe&width=400&height=560&seq=show-card-06&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Louisiana%20bayou%20landscape%20True%20Detective%20style%20dark%20swamp%20at%20dusk%20industrial%20ruins%20in%20distance%20foggy%20atmosphere%20dead%20trees%20silhouette%20cinematic%20wide%20shot%20eerie%20southern%20gothic%20mood&width=1400&height=700&seq=hero-show-06&orientation=landscape'
  },
  {
    id: 7,
    title: '切尔诺贝利',
    englishTitle: 'Chernobyl',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.6,
    year: 2019,
    seasons: 1,
    status: '已完结',
    description: '1986年切尔诺贝利核电站爆炸事故的真实再现，讲述了那些为阻止更大灾难而牺牲的英雄们的故事，以及谎言与真相之间的博弈。',
    longDescription: '《切尔诺贝利》以1986年苏联切尔诺贝利核电站爆炸事故为背景，是HBO出品的一部五集限定剧。剧集从爆炸当晚开始，真实还原了这场人类历史上最严重的核灾难。从最初的事故发生、政府试图掩盖真相，到科学家们勇敢揭露事实、矿工们在高温辐射下挖掘隧道、军人们冒着生命危险清理核废料——这部剧以近乎纪录片的质感，展现了灾难中的人性光辉与制度之恶。每集都令人窒息紧张，同时发人深省，获得了极高的评价和多项艾美奖。',
    director: '约翰·伦克',
    cast: ['杰瑞德·哈里斯', '斯特兰·斯卡斯加德', '艾米丽·沃森', '杰西·巴克利'],
    tags: ['历史', '灾难', '真实事件', '限定剧'],
    updateDay: '已完结',
    views: 8230000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chernobyl%20HBO%20miniseries%20poster%20Soviet%20industrial%20disaster%20theme%20radiation%20symbol%20dark%20ominous%20atmosphere%20professional%20poster%20design%20simple%20dark%20background%20gas%20mask%20motif&width=400&height=560&seq=show-card-07&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Abandoned%20Soviet%20industrial%20complex%20Chernobyl%20style%20desolate%20landscape%20gray%20overcast%20sky%20nuclear%20cooling%20tower%20in%20distance%20eerie%20atmosphere%20abandoned%20city%20cinematic%20wide%20shot%20documentary%20realism&width=1400&height=700&seq=hero-show-07&orientation=landscape'
  },
  {
    id: 8,
    title: '纸牌屋',
    englishTitle: 'House of Cards',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.1,
    year: 2013,
    seasons: 6,
    status: '已完结',
    description: '一个野心勃勃的国会议员在政治野心受挫后，与同样冷酷的妻子一起，不惜一切代价向权力顶峰攀登的黑暗政治剧。',
    longDescription: '《纸牌屋》是一部关于华盛顿政治权术的黑暗剧集。弗兰克·安德伍德是一位老谋深算的国会议员，当他在新一届政府组建中被背叛后，他与妻子克莱尔一起策划了一场精心布局的复仇计划。通过操纵、威胁、欺骗和谋杀，弗兰克一步步爬上权力的顶峰。本剧以其第四面墙的叙事手法——弗兰克经常直接对着镜头向观众吐露心声——而著称，让观众成为他阴谋的共谋者。虽然后期因为主演丑闻而受到争议，但前几季对政治黑暗面的刻画堪称经典。',
    director: '鲍尔·威利蒙',
    cast: ['凯文·史派西', '罗宾·怀特', '迈克尔·凯利', '凯特·玛拉', '寇瑞·斯托尔'],
    tags: ['政治', '权谋', '黑暗', '华盛顿'],
    updateDay: '已完结',
    views: 7560000,
    imageUrl: 'https://readdy.ai/api/search-image?query=House%20of%20Cards%20political%20drama%20poster%20US%20Capitol%20building%20silhouette%20dark%20power%20theme%20professional%20poster%20design%20simple%20dark%20background%20upside%20down%20American%20flag%20motif&width=400&height=560&seq=show-card-08&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Washington%20DC%20skyline%20at%20night%20House%20of%20Cards%20style%20US%20Capitol%20dome%20illuminated%20dark%20rainy%20streets%20political%20power%20theme%20cinematic%20wide%20shot%20dramatic%20lighting%20ominous%20atmosphere&width=1400&height=700&seq=hero-show-08&orientation=landscape'
  },
  {
    id: 9,
    title: '瑞克和莫蒂',
    englishTitle: 'Rick and Morty',
    category: '动画',
    categorySlug: 'animation',
    rating: 9.3,
    year: 2013,
    seasons: 7,
    status: '连载中',
    description: '天才但酗酒的科学家瑞克带着他胆小怕事的外孙莫蒂，穿越多元宇宙展开疯狂冒险的成人动画喜剧。',
    longDescription: '《瑞克和莫蒂》是一部面向成人观众的科幻动画喜剧。天才科学家瑞克·桑切斯在失踪多年后突然回到女儿家中，带着他14岁的外孙莫蒂穿梭于不同的维度和平行宇宙，展开一系列疯狂而危险的冒险。瑞克是一个愤世嫉俗、酗酒成性的超级天才，他拥有传送枪和各种匪夷所思的发明；莫蒂则是一个善良但不太聪明的普通男孩。两人在冒险中经历了无数荒谬、暴力又充满哲学思辨的事件。本剧以快节奏的对话、黑色幽默和深刻的虚无主义主题而闻名，是当代最具影响力的动画作品之一。',
    director: '贾斯汀·罗兰 / 丹·哈蒙',
    cast: ['贾斯汀·罗兰', '克里斯·帕内尔', '斯宾瑟·格拉默', '莎拉·乔克'],
    tags: ['动画', '科幻', '黑色幽默', '成人向'],
    updateDay: '不定期更新',
    views: 8450000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Rick%20and%20Morty%20animated%20show%20poster%20sci%20fi%20cartoon%20style%20portal%20gun%20green%20effect%20cosmic%20background%20colorful%20professional%20poster%20design%20simple%20dark%20background%20animated%20characters%20silhouette&width=400&height=560&seq=show-card-09&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Cosmic%20multi%20universe%20landscape%20Rick%20and%20Morty%20style%20green%20portal%20in%20sky%20colorful%20galaxy%20background%20surreal%20planets%20floating%20sci%20fi%20cartoon%20aesthetic%20cinematic%20wide%20shot%20vibrant%20colors&width=1400&height=700&seq=hero-show-09&orientation=landscape'
  },
  {
    id: 10,
    title: '风骚律师',
    englishTitle: 'Better Call Saul',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.5,
    year: 2015,
    seasons: 6,
    status: '已完结',
    description: '绝命毒师前传，讲述一个小律师吉米·麦吉尔如何在法律世界的灰色地带中，一步步蜕变为那个我们熟悉的"索尔·古德曼"。',
    longDescription: '《风骚律师》是《绝命毒师》的前传衍生剧，讲述了吉米·麦吉尔如何从一个挣扎求生的小律师，逐渐变成那个在《绝命毒师》中我们熟悉的滑头律师"索尔·古德曼"。故事设定在《绝命毒师》事件的六年前，通过交错的时间线，也展现了绝命毒师之后吉米的逃亡生活。本剧不仅完美继承了《绝命毒师》的高品质叙事，还通过独特的视觉风格、精彩的法庭戏份和深入的人物刻画，独立成为一部堪称伟大的作品。鲍勃·奥登科克和蕾亚·塞洪的表演令人叹服。',
    director: '文斯·吉里根 / 彼得·古尔德',
    cast: ['鲍勃·奥登科克', '蕾亚·塞洪', '乔纳森·班克斯', '吉安卡罗·埃斯波西托', '迈克尔·曼多'],
    tags: ['犯罪', '律政', '前传', '黑色幽默'],
    updateDay: '已完结',
    views: 7890000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Better%20Call%20Saul%20TV%20show%20poster%20lawyer%20in%20colorful%20suit%20desert%20backdrop%20warm%20tones%20professional%20poster%20design%20simple%20background%20neon%20sign%20motif%20criminal%20lawyer%20theme&width=400&height=560&seq=show-card-10&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Albuquerque%20desert%20landscape%20Better%20Call%20Saul%20style%20strip%20mall%20at%20sunset%20neon%20signs%20glowing%20warm%20golden%20light%20empty%20parking%20lot%20cinematic%20wide%20shot%20nostalgic%20Americana%20feel&width=1400&height=700&seq=hero-show-10&orientation=landscape'
  },
  {
    id: 11,
    title: '西部世界',
    englishTitle: 'Westworld',
    category: '科幻',
    categorySlug: 'sci-fi',
    rating: 8.5,
    year: 2016,
    seasons: 4,
    status: '已完结',
    description: '在一个由高度仿真机器人构成的未来主题公园中，富豪游客们可以尽情释放欲望。但当机器人开始产生意识，一切都失控了。',
    longDescription: '《西部世界》改编自迈克尔·克莱顿1973年的同名电影，设定在一个由高科技机器人"接待员"构成的未来主题公园。游客支付高昂费用进入这个西部世界，可以自由地与机器人互动甚至施暴而不受惩罚。然而，当一部分机器人开始觉醒并获得意识后，一场革命悄然展开。本剧以复杂的多线叙事探讨了人工智能、意识本质、自由意志和人性等深刻哲学命题，配合震撼的视觉效果和精湛的配乐，是HBO继《权力的游戏》之后最具野心的作品。',
    director: '乔纳森·诺兰 / 丽莎·乔伊',
    cast: ['埃文·蕾切尔·伍德', '坦迪·牛顿', '杰弗里·怀特', '艾德·哈里斯', '安东尼·霍普金斯'],
    tags: ['科幻', '人工智能', '哲学', '动作'],
    updateDay: '已完结',
    views: 7230000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Westworld%20TV%20show%20poster%20futuristic%20western%20theme%20android%20robot%20being%20created%20dramatic%20lighting%20professional%20poster%20design%20simple%20dark%20background%20circular%20maze%20motif&width=400&height=560&seq=show-card-11&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Western%20desert%20landscape%20Westworld%20style%20futuristic%20laboratory%20underneath%20old%20western%20town%20contrast%20of%20old%20and%20new%20cinematic%20wide%20shot%20dramatic%20sky%20canyon%20vista%20professional%20photography&width=1400&height=700&seq=hero-show-11&orientation=landscape'
  },
  {
    id: 12,
    title: '行尸走肉',
    englishTitle: 'The Walking Dead',
    category: '恐怖',
    categorySlug: 'horror',
    rating: 8.1,
    year: 2010,
    seasons: 11,
    status: '已完结',
    description: '警官瑞克从昏迷中醒来后发现世界已被丧尸占领，他带领一群幸存者在末日世界中为生存而战，但最可怕的不是丧尸，而是人心。',
    longDescription: '《行尸走肉》是AMC电视台出品的一部丧尸末日题材剧集。警察瑞克·格莱姆斯在一次任务中重伤昏迷，当他醒来后，发现整个世界已经被丧尸占领。他踏上了寻找家人的旅程，并逐渐成为一群幸存者的领袖。在长达十一季的故事中，这群人不仅要与无数的丧尸搏斗，更要面对来自其他幸存者群体的威胁——因为在末日世界里，活人往往比死人更可怕。本剧以其残酷的生存叙事、深刻的人性探讨和不吝惜杀主角的勇气闻名。',
    director: '弗兰克·德拉邦特',
    cast: ['安德鲁·林肯', '诺曼·瑞杜斯', '达娜·古瑞拉', '梅丽莎·麦克布莱德', '劳伦·科汉'],
    tags: ['丧尸', '末日', '生存', '人性'],
    updateDay: '已完结',
    views: 9120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Walking%20Dead%20TV%20show%20poster%20post%20apocalyptic%20theme%20lonely%20survivor%20with%20weapon%20desolate%20landscape%20professional%20poster%20design%20simple%20dark%20background%20zombie%20apocalypse%20motif&width=400&height=560&seq=show-card-12&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20city%20landscape%20The%20Walking%20Dead%20style%20abandoned%20highway%20overturned%20cars%20overgrown%20buildings%20gray%20sky%20desolate%20atmosphere%20survival%20theme%20cinematic%20wide%20shot%20eerie%20silence&width=1400&height=700&seq=hero-show-12&orientation=landscape'
  },
  {
    id: 13,
    title: '生活大爆炸',
    englishTitle: 'The Big Bang Theory',
    category: '喜剧',
    categorySlug: 'comedy',
    rating: 9.4,
    year: 2007,
    seasons: 12,
    status: '已完结',
    description: '四个高智商但社交笨拙的理工男与他们的美女邻居之间的爆笑日常，用科学和极客文化带来了无数欢乐时光。',
    longDescription: '《生活大爆炸》是一部围绕着一群天才科学家和他们的社交生活展开的情景喜剧。物理学家谢尔顿和莱纳德是加州理工学院的室友，他们智商超群但社交能力堪忧，在漫画书、科幻电影和电子游戏中寻找慰藉。当他们美丽的邻居佩妮搬到对面后，这群极客的世界开始发生微妙的变化。十二季中，我们见证了谢尔顿从完全不懂人情世故到最终找到真爱，看到了这群"怪胎"们的成长、友情和爱情。本剧将高深的科学术语与日常生活幽默完美融合，是全球最受欢迎的情景喜剧之一。',
    director: '查克·罗瑞 / 比尔·普拉迪',
    cast: ['吉姆·帕森斯', '约翰尼·盖尔克奇', '凯莉·库柯', '西蒙·赫尔伯格', '昆瑙·内亚'],
    tags: ['情景喜剧', '极客', '科学', '友情'],
    updateDay: '已完结',
    views: 9680000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Big%20Bang%20Theory%20TV%20show%20poster%20group%20of%20geeky%20scientists%20in%20apartment%20living%20room%20comic%20book%20theme%20colorful%20warm%20lighting%20professional%20poster%20design%20simple%20background%20nerdy%20fun%20vibe&width=400&height=560&seq=show-card-13&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Pasadena%20California%20neighborhood%20The%20Big%20Bang%20Theory%20style%20apartment%20building%20exterior%20warm%20sunny%20day%20comic%20book%20store%20on%20street%20corner%20cheerful%20atmosphere%20cinematic%20wide%20shot%20friendly%20neighborhood&width=1400&height=700&seq=hero-show-13&orientation=landscape'
  },
  {
    id: 14,
    title: '冰血暴',
    englishTitle: 'Fargo',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 9.0,
    year: 2014,
    seasons: 5,
    status: '连载中',
    description: '每一季讲述一个发生在明尼苏达州冰天雪地中的犯罪故事，看似普通的案件总是以最出人意料的方式失控，充满黑色幽默和荒诞感。',
    longDescription: '《冰血暴》灵感来源于科恩兄弟1996年的同名电影，每季讲述一个独立的犯罪故事，均发生在美国明尼苏达州寒冷的小镇上。看似平凡的小人物因为一次偶然的决定，被卷入越来越失控的犯罪漩涡中。本剧以其独特的黑色幽默风格、复杂精巧的多线叙事和令人难忘的角色而著称。从第一季的马丁·弗瑞曼和比利·鲍勃·松顿，到后续各季的克里斯汀·邓斯特、伊万·麦克格雷格等，每一季都汇集了顶级演员阵容，打造出令人拍案叫绝的犯罪传奇。',
    director: '诺亚·霍利',
    cast: ['比利·鲍勃·松顿', '马丁·弗瑞曼', '克里斯汀·邓斯特', '伊万·麦克格雷格', '朱诺·坦普尔'],
    tags: ['犯罪', '黑色幽默', '独立季', '荒诞'],
    updateDay: '不定期更新',
    views: 6340000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Fargo%20TV%20show%20poster%20snowy%20Minnesota%20winter%20crime%20theme%20blood%20on%20snow%20dark%20humor%20feel%20professional%20poster%20design%20simple%20white%20background%20minimalist%20Scandinavian%20style&width=400&height=560&seq=show-card-14&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Snowy%20Minnesota%20winter%20landscape%20Fargo%20style%20endless%20white%20fields%20lonely%20car%20on%20frozen%20highway%20small%20town%20in%20distance%20overcast%20sky%20cinematic%20wide%20shot%20cold%20isolated%20atmosphere%20minimalist&width=1400&height=700&seq=hero-show-14&orientation=landscape'
  },
  {
    id: 15,
    title: '无耻之徒',
    englishTitle: 'Shameless',
    category: '喜剧',
    categorySlug: 'comedy',
    rating: 9.2,
    year: 2011,
    seasons: 11,
    status: '已完结',
    description: '芝加哥南区的一个贫困大家庭中，酗酒父亲不靠谱，大姐菲奥娜独自承担起抚养五个弟妹的重任，在底层生活中顽强生存。',
    longDescription: '《无耻之徒》讲述了加拉格一家在芝加哥南区底层社区的生存故事。酒鬼父亲弗兰克整日酗酒不思进取，六个孩子在大姐菲奥娜的带领下，用自己的方式在这个残酷的世界中挣扎求生。他们偷窃、诈骗、撒谎，但也彼此深爱、互相扶持。本剧以一种毫不遮掩的方式展示了美国底层白人的生活困境，充满了粗俗但令人捧腹的幽默，同时又蕴含着深刻的社会批判和对家庭价值的真挚歌颂。长达十一季中，观众与加拉格一家一起经历了无数欢笑与泪水。',
    director: '约翰·威尔斯',
    cast: ['威廉·H·梅西', '艾美·罗森', '杰瑞米·艾伦·怀特', '伊桑·库考斯基', '莎诺拉·汉普顿'],
    tags: ['家庭', '底层', '黑色幽默', '成长'],
    updateDay: '已完结',
    views: 8120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Shameless%20TV%20show%20poster%20chaotic%20family%20in%20Chicago%20south%20side%20house%20messy%20living%20room%20gritty%20realistic%20style%20professional%20poster%20design%20simple%20background%20working%20class%20neighborhood%20feel&width=400&height=560&seq=show-card-15&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Chicago%20south%20side%20neighborhood%20Shameless%20style%20row%20houses%20on%20street%20working%20class%20area%20gritty%20urban%20landscape%20overcast%20day%20cinematic%20wide%20shot%20realistic%20drama%20feel&width=1400&height=700&seq=hero-show-15&orientation=landscape'
  },
  {
    id: 16,
    title: '毒枭',
    englishTitle: 'Narcos',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 9.2,
    year: 2015,
    seasons: 3,
    status: '已完结',
    description: '真实再现哥伦比亚大毒枭巴勃罗·埃斯科瓦尔的崛起与覆灭，以及美国缉毒局与哥伦比亚政府联手追捕他的惊心动魄历程。',
    longDescription: '《毒枭》基于真实事件改编，讲述哥伦比亚最臭名昭著的大毒枭巴勃罗·埃斯科瓦尔的传奇一生。从走私小贩到掌控全球可卡因交易的毒品帝国之王，埃斯科瓦尔以暴力和贿赂征服一切，一度成为世界上最富有、最危险的人物之一。与此同时，美国缉毒局特工史蒂夫·墨菲和哈维尔·佩尼亚来到哥伦比亚，与当地政府联手追捕这位不可一世的毒枭。本剧采用半纪录片式的叙事风格，穿插大量真实历史影像，营造出强烈的真实感和沉浸感，被公认为Netflix最佳原创剧集之一。',
    director: '克里斯·布兰卡托',
    cast: ['瓦格纳·马拉', '波伊德·霍布鲁克', '佩德罗·帕斯卡', '保罗娜·盖坦'],
    tags: ['犯罪', '传记', '真实事件', '毒品'],
    updateDay: '已完结',
    views: 7890000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Narcos%20TV%20show%20poster%20Colombian%20drug%20cartel%20theme%20Pablo%20Escobar%20silhouette%20gun%20and%20money%20warm%20tropical%20tones%20professional%20poster%20design%20simple%20background%201980s%20aesthetic&width=400&height=560&seq=show-card-16&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Medellin%20Colombia%20cityscape%20Narcos%20style%20colorful%20hillside%20neighborhoods%201980s%20cars%20on%20streets%20warm%20tropical%20sunlight%20cinematic%20wide%20shot%20vibrant%20Latin%20American%20atmosphere&width=1400&height=700&seq=hero-show-16&orientation=landscape'
  },
  {
    id: 17,
    title: '黑袍纠察队',
    englishTitle: 'The Boys',
    category: '动作',
    categorySlug: 'action',
    rating: 8.7,
    year: 2019,
    seasons: 4,
    status: '连载中',
    description: '在一个超级英雄被大公司包装成明星的世界里，一群普通人组成"黑袍纠察队"，誓要揭露这些腐败"英雄"的真面目。',
    longDescription: '《黑袍纠察队》设定在一个超级英雄真实存在的世界，但这些"英雄"并非正义的化身——他们由沃特国际公司管理和包装，享受着明星般的待遇，私下却滥用权力、腐败堕落。当主人公休伊的女友被超级英雄"火车头"意外撞死后，他加入了由前特工布彻领导的"黑袍纠察队"，一群人用尽各种手段要与这些不可一世的超级英雄对抗。本剧以极度暴力、讽刺和黑色幽默的方式，对超级英雄文化和资本主义进行了尖锐的批判，是反超级英雄题材的代表作。',
    director: '埃里克·克莱普克',
    cast: ['卡尔·厄本', '杰克·奎德', '安东尼·斯塔尔', '艾琳·莫里亚蒂', '多米妮克·麦克艾丽戈特'],
    tags: ['反英雄', '动作', '讽刺', '暴力'],
    updateDay: '每周四更新',
    views: 7560000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Boys%20TV%20show%20poster%20anti%20superhero%20theme%20dark%20gritty%20style%20broken%20superhero%20cape%20on%20ground%20professional%20poster%20design%20simple%20dark%20background%20rebellion%20motif&width=400&height=560&seq=show-card-17&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Urban%20cityscape%20The%20Boys%20style%20corporate%20skyscraper%20with%20superhero%20billboard%20dark%20gritty%20streets%20below%20contrast%20of%20wealth%20and%20poverty%20cinematic%20wide%20shot%20satirical%20dystopia%20theme&width=1400&height=700&seq=hero-show-17&orientation=landscape'
  },
  {
    id: 18,
    title: '王冠',
    englishTitle: 'The Crown',
    category: '剧情',
    categorySlug: 'drama',
    rating: 8.7,
    year: 2016,
    seasons: 6,
    status: '已完结',
    description: '讲述伊丽莎白二世女王从即位到现在跨越数十年的政治风云与个人生活，展现了大英帝国在现代世界的变迁与王室背后的故事。',
    longDescription: '《王冠》是Netflix出品的历史传记剧，以英国女王伊丽莎白二世的一生为主线，从1947年她与菲利普亲王成婚开始，跨越数十年展现大英帝国的变迁和王室内部的复杂关系。每一季聚焦女王生命中的不同阶段，从温斯顿·丘吉尔首相时期的政治博弈，到戴安娜王妃的悲剧故事。本剧以精致的服装道具、考究的历史还原和卓越的演员演绎，获得了评论界和观众的一致好评，多次斩获艾美奖和金球奖最佳剧集。',
    director: '彼得·摩根',
    cast: ['克莱尔·芙伊', '奥利维娅·科尔曼', '伊梅尔达·斯汤顿', '马特·史密斯', '托比亚斯·门基斯'],
    tags: ['历史', '传记', '王室', '英国'],
    updateDay: '已完结',
    views: 6670000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Crown%20TV%20show%20poster%20British%20royal%20crown%20on%20velvet%20cushion%20elegant%20regal%20style%20gold%20and%20deep%20red%20tones%20professional%20poster%20design%20simple%20dark%20background%20monarchy%20theme&width=400&height=560&seq=show-card-18&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Buckingham%20Palace%20London%20The%20Crown%20style%20grand%20palace%20facade%20at%20sunset%20changing%20of%20the%20guard%20ceremony%20elegant%20atmosphere%20cinematic%20wide%20shot%20British%20heritage%20grandeur&width=1400&height=700&seq=hero-show-18&orientation=landscape'
  },
  {
    id: 19,
    title: '曼达洛人',
    englishTitle: 'The Mandalorian',
    category: '科幻',
    categorySlug: 'sci-fi',
    rating: 8.7,
    year: 2019,
    seasons: 3,
    status: '连载中',
    description: '星球大战宇宙中的赏金猎人曼达洛人，在一次任务中遇到了可爱的小尤达（格洛古），从此踏上了一场跨越银河的冒险之旅。',
    longDescription: '《曼达洛人》是星球大战系列的首部真人剧集，故事设定在帝国覆灭后、第一秩序崛起前的银河系边缘。一位独行侠赏金猎人曼达洛人·丁·贾伦，在一次任务中意外遇到了一个神秘的外星婴儿——格洛古（被粉丝亲切地称为"小尤达"或"宝宝尤达"）。他违背了赏金猎人守则，决定保护这个孩子，两人在银河系的边缘地带展开了一场惊心动魄的冒险。本剧以西部片风格的叙事、史诗级的视觉效果和令人无法抗拒的可爱主角，成为Disney+最成功的原创剧集。',
    director: '乔恩·费儒',
    cast: ['佩德罗·帕斯卡', '卡尔·韦瑟斯', '吉娜·卡拉诺', '吉安卡罗·埃斯波西托'],
    tags: ['星球大战', '科幻', '冒险', '西部'],
    updateDay: '不定期更新',
    views: 8890000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Mandalorian%20TV%20show%20poster%20Star%20Wars%20bounty%20hunter%20in%20armor%20baby%20Yoda%20Grogu%20silhouette%20space%20western%20theme%20professional%20poster%20design%20simple%20dark%20background%20epic%20sci%20fi&width=400&height=560&seq=show-card-19&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Alien%20desert%20planet%20landscape%20The%20Mandalorian%20style%20twin%20suns%20setting%20over%20dunes%20spaceship%20Razor%20Crest%20in%20distance%20Star%20Wars%20universe%20cinematic%20wide%20shot%20epic%20sci%20fi%20western&width=1400&height=700&seq=hero-show-19&orientation=landscape'
  },
  {
    id: 20,
    title: '汉尼拔',
    englishTitle: 'Hannibal',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 8.6,
    year: 2013,
    seasons: 3,
    status: '已完结',
    description: 'FBI特别调查员威尔·格雷厄姆在追查连环杀手时，向才华横溢的精神病学家汉尼拔·莱克特寻求帮助，却不知自己正在与最危险的杀手共进晚餐。',
    longDescription: '《汉尼拔》是一部心理惊悚剧，改编自托马斯·哈里斯的小说《红龙》。FBI特别调查员威尔·格雷厄姆拥有超乎常人的共情能力，可以深入理解连环杀手的心理，但这也在不断侵蚀他的精神健康。他的心理医生——优雅博学的汉尼拔·莱克特博士——表面上在帮助威尔，实际上却在暗中操纵一切。本剧以其令人窒息的悬疑氛围、极致的视觉美学（每一帧都像油画）和对人性阴暗面的深刻探索而著称。麦斯·米科尔森演绎的汉尼拔优雅而恐怖，成为这一经典角色的又一个标杆。',
    director: '布莱恩·福勒',
    cast: ['麦斯·米科尔森', '休·丹西', '劳伦斯·菲什伯恩', '吉莲·安德森'],
    tags: ['悬疑', '心理', '恐怖', '美学'],
    updateDay: '已完结',
    views: 5340000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Hannibal%20TV%20show%20poster%20psychological%20thriller%20theme%20elegant%20dinner%20table%20with%20wine%20glass%20dark%20gothic%20aesthetic%20professional%20poster%20design%20simple%20dark%20background%20artistic%20horror&width=400&height=560&seq=show-card-20&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20dining%20room%20Hannibal%20style%20candlelit%20table%20setting%20dark%20gothic%20interior%20antlers%20on%20wall%20fine%20art%20painting%20aesthetic%20cinematic%20wide%20shot%20luxurious%20yet%20ominous%20atmosphere&width=1400&height=700&seq=hero-show-20&orientation=landscape'
  },
  {
    id: 21,
    title: '杀死伊芙',
    englishTitle: 'Killing Eve',
    category: '动作',
    categorySlug: 'action',
    rating: 8.2,
    year: 2018,
    seasons: 4,
    status: '已完结',
    description: '一个无聊的英国情报人员和一个迷人的国际杀手之间展开了一场猫鼠游戏，两人在追捕和对抗中产生了危险而迷人的迷恋。',
    longDescription: '《杀死伊芙》是一部充满黑色幽默和时尚感的间谍惊悚剧。伊芙·波拉斯特里是英国军情五处的一名普通文职人员，她对女性杀手的心理有着异乎寻常的痴迷。当她在追踪一位神秘的国际杀手薇拉内尔时，两人之间展开了一场跨越欧洲的猫鼠游戏。然而，随着追捕的深入，伊芙和薇拉内尔之间的关系变得越来越复杂——她们既是对手，又彼此深深吸引。本剧以大胆的叙事、独特的视觉风格和两位女主角之间令人窒息的化学反应，成为近年来最具原创性的剧集之一。',
    director: '菲比·沃勒-布里奇',
    cast: ['吴珊卓', '朱迪·科默', '费奥纳·肖', '金·博迪尼亚'],
    tags: ['间谍', '惊悚', '猫鼠游戏', '女性向'],
    updateDay: '已完结',
    views: 5670000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Killing%20Eve%20TV%20show%20poster%20female%20spy%20thriller%20theme%20fashionable%20assassin%20in%20designer%20clothes%20bold%20colors%20professional%20poster%20design%20simple%20background%20elegant%20dangerous%20vibe&width=400&height=560&seq=show-card-21&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=European%20city%20street%20Killing%20Eve%20style%20Paris%20or%20London%20elegant%20boutique%20shopping%20street%20fashionable%20woman%20in%20distance%20cinematic%20wide%20shot%20stylish%20thriller%20atmosphere&width=1400&height=700&seq=hero-show-21&orientation=landscape'
  },
  {
    id: 22,
    title: '黄石',
    englishTitle: 'Yellowstone',
    category: '动作',
    categorySlug: 'action',
    rating: 8.7,
    year: 2018,
    seasons: 5,
    status: '连载中',
    description: '在蒙大拿州广袤的草原上，达顿家族为守护美国最大的连片牧场而战，对抗土地开发商、印第安保留地和政客们的步步紧逼。',
    longDescription: '《黄石》讲述了达顿家族守护美国最大连片牧场的故事。约翰·达顿是美国最大牧场的主人，他的家族在蒙大拿州生活了数代。但如今，他的牧场面临来自四面八方的威胁——贪婪的房地产开发商想夺走土地建度假村，邻近的印第安保留区要求归还祖传领地，腐败的政客们更是暗中使绊。约翰和他的子女们不惜一切代价守护这片土地，包括暴力。本剧以壮美的西部风光、紧张刺激的家族斗争和对现代西部生活的真实刻画，成为当下美国收视率最高的剧集之一。',
    director: '泰勒·谢里丹',
    cast: ['凯文·科斯特纳', '卢克·葛莱姆斯', '凯莉·蕾莉', '韦斯·本特利', '科尔·豪瑟'],
    tags: ['西部', '家族', '现代', '土地'],
    updateDay: '每周一更新',
    views: 8230000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Yellowstone%20TV%20show%20poster%20modern%20western%20theme%20cowboy%20on%20horseback%20against%20mountain%20backdrop%20ranch%20life%20professional%20poster%20design%20simple%20background%20American%20West%20feel&width=400&height=560&seq=show-card-22&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Montana%20ranch%20landscape%20Yellowstone%20style%20vast%20green%20pastures%20with%20grazing%20cattle%20snow%20capped%20mountains%20in%20background%20wooden%20ranch%20house%20cinematic%20wide%20shot%20American%20West%20grandeur&width=1400&height=700&seq=hero-show-22&orientation=landscape'
  },
  {
    id: 23,
    title: '美国恐怖故事',
    englishTitle: 'American Horror Story',
    category: '恐怖',
    categorySlug: 'horror',
    rating: 8.0,
    year: 2011,
    seasons: 12,
    status: '连载中',
    description: '每一季讲述一个全新的恐怖故事，从鬼屋到疯人院，从女巫集会到畸形秀，用极致恐怖包裹深刻的社会议题。',
    longDescription: '《美国恐怖故事》是一部独立季播的恐怖剧集，每季讲述一个独立且完整的恐怖故事。从第一季令人毛骨悚然的"谋杀屋"，到话题度爆表的"女巫集会"，再到视觉冲击力极强的"畸形秀"——每一季都以不同的恐怖主题探索人性最黑暗的角落。本剧由恐怖大师瑞恩·墨菲打造，以同一批核心演员在不同季中扮演不同角色的创新方式，为每一季注入新鲜感。除了极致恐怖和血腥场面，每季还深入探讨了社会边缘群体、身份认同、家庭创伤等深刻话题。',
    director: '瑞恩·墨菲 / 布拉德·法尔查克',
    cast: ['莎拉·保罗森', '埃文·彼得斯', '杰西卡·兰格', '凯西·贝茨', '安吉拉·贝塞特'],
    tags: ['恐怖', '独立季', '超自然', '社会议题'],
    updateDay: '不定期更新',
    views: 6780000,
    imageUrl: 'https://readdy.ai/api/search-image?query=American%20Horror%20Story%20TV%20show%20poster%20creepy%20gothic%20mansion%20at%20night%20full%20moon%20dark%20horror%20atmosphere%20professional%20poster%20design%20simple%20dark%20background%20haunted%20house%20motif&width=400&height=560&seq=show-card-23&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=Haunted%20Victorian%20mansion%20American%20Horror%20Story%20style%20foggy%20night%20with%20full%20moon%20creepy%20dead%20trees%20silhouette%20iron%20gate%20cinematic%20wide%20shot%20classic%20horror%20atmosphere%20gothic&width=1400&height=700&seq=hero-show-23&orientation=landscape'
  },
  {
    id: 24,
    title: '了不起的麦瑟尔夫人',
    englishTitle: 'The Marvelous Mrs. Maisel',
    category: '喜剧',
    categorySlug: 'comedy',
    rating: 8.7,
    year: 2017,
    seasons: 5,
    status: '已完结',
    description: '1950年代的纽约，一个完美主妇在丈夫出轨后意外发现了自己的脱口秀天赋，从此踏上了追求喜剧梦想的道路。',
    longDescription: '《了不起的麦瑟尔夫人》以1950年代末的纽约为背景。米琪·麦瑟尔是一个堪称完美的犹太裔家庭主妇，拥有精致的公寓、两个可爱的孩子和一个看似完美的丈夫。直到一天晚上，丈夫突然宣布他爱上了自己的秘书并离家出走。醉醺醺的米琪跌跌撞撞来到一家地下喜剧俱乐部，即兴拿起话筒吐槽起了自己的悲惨遭遇——没想到她天生的幽默感和机智赢得了满堂喝彩。从此，米琪开始了她的脱口秀生涯，在一个由男性主导的行业中奋力前行。本剧以精致的时代还原、快速的机智对话和迷人的服装设计获得了多项艾美奖。',
    director: '艾米·谢尔曼-帕拉迪诺',
    cast: ['瑞秋·布罗斯纳安', '亚历克斯·布诺斯坦', '迈克尔·泽根', '托尼·夏尔赫布'],
    tags: ['喜剧', '女性', '50年代', '脱口秀'],
    updateDay: '已完结',
    views: 6120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Marvelous%20Mrs%20Maisel%20TV%20show%20poster%201950s%20elegant%20woman%20in%20vintage%20dress%20on%20stage%20with%20microphone%20retro%20style%20professional%20poster%20design%20simple%20background%20mid%20century%20aesthetic&width=400&height=560&seq=show-card-24&orientation=portrait',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=1950s%20New%20York%20City%20street%20The%20Marvelous%20Mrs%20Maisel%20style%20vintage%20cars%20and%20fashion%20Washington%20Square%20Park%20autumn%20leaves%20cinematic%20wide%20shot%20nostalgic%20elegant%20atmosphere&width=1400&height=700&seq=hero-show-24&orientation=landscape'
  },
];

export const heroShows: Show[] = [shows[0], shows[2], shows[4], shows[6], shows[9]];

export const latestShows: Show[] = [shows[1], shows[16], shows[21], shows[18], shows[19]];

export const recommendedShows: Show[] = [shows[3], shows[5], shows[8], shows[12], shows[13], shows[14], shows[15], shows[20]];

export const hotShows: Show[] = [shows[0], shows[2], shows[4], shows[1], shows[8], shows[9], shows[12], shows[16]];